// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"48":"558e2fea","348":"11a3ea35","453":"50ec7b58","457":"1eb306f6","831":"782bf6a9","842":"4b4ef584"}[chunkId] + ".chunk.js";
};